const SingleCardLayout = ({ children }) => {
  return (
    <div className="h-screen w-full flex items-center justify-center bg-slate-100">
      {children}
    </div>
  );
};

export default SingleCardLayout;
